import { Input } from 'design-system-web';

export default Input;
